import src from "IMAGE";
export default { src, width: 1076, height: 378, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
